import { render } from "./mySettings.vue?vue&type=template&id=3859c7a0&scoped=true"
import script from "./mySettings.vue?vue&type=script&lang=js"
export * from "./mySettings.vue?vue&type=script&lang=js"

import "./mySettings.vue?vue&type=style&index=0&id=3859c7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3859c7a0"]])

export default __exports__